import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { computeNavV6 } from './useNavV6';
import { hubForPath } from './navModel';

/**
 * Safe (never throws without a QueryClientProvider / Router-less test tree) reader of the new navigation state
 * for components that render on every page (Navbar) or inside pages (titles): { navV6, hub } where `hub` is the
 * hub the CURRENT route belongs to (null outside hubs, and always null while the switch is off).
 */
export function useNavHub() {
  const redux = useSelector((s) => s.global?.companyDetails);
  let cached;
  // eslint-disable-next-line react-hooks/rules-of-hooks -- always called; the try only tolerates a missing provider
  try { cached = useQueryClient().getQueryData('getUserSubscription'); } catch (_) { cached = undefined; }
  let loc = { pathname: '/', state: undefined };
  // eslint-disable-next-line react-hooks/rules-of-hooks -- always called; the try only tolerates a missing router
  try { loc = useLocation(); } catch (_) { /* no router: not in a hub */ }
  const details = cached ?? redux ?? null;
  const navV6 = computeNavV6(details);
  if (!navV6) return { navV6: false, hub: null };
  const features = details?.package?.features || {};
  const has = (k) => features[k] !== false;
  return { navV6, hub: hubForPath(loc.pathname, { has, features }, loc.state) };
}

/** True while the new navigation is on AND the current route belongs to a hub (the hub tab bar names the page). */
export function useInHub() {
  return !!useNavHub().hub;
}

export default useInHub;
